const initialState = {
  list: [],
  banner: {},
  paging: {},
  sending: false,
  redirect: null
}

const identifier = 'banner'

export default (state = initialState, action) => {
  let nextState = Object.assign({}, state)

  switch (action.type) {
    case 'BEFORE_SEND':
      if (action.identifier === identifier) {
        nextState = Object.assign(nextState, {
          sending: true
        })
      }
      break

    case 'AFTER_RESPONSE':
      if (action.identifier === identifier) {
        nextState = Object.assign(nextState, {
          sending: false
        })
      }
      break

    case 'SET_BANNERS':
      nextState = Object.assign(nextState, {
        list: action.data,
        paging: action.paging,
        redirect: null
      })
      break

    case 'ADD_BANNER':
      nextState.list = [action.data].concat(nextState.list)
      nextState.redirect = '/banners'
      break

    case 'SET_BANNER':
      nextState.banner = action.data
      break

    case 'UPDATE_BANNER':
      nextState = Object.assign(nextState, {
        list: nextState.list.map(item => {
          if (+item.id === +action.data.id) {
            item = { ...action.data }
          }
          return item
        })
      })
      nextState.redirect = '/banners'
      break

    case 'DELETE_BANNER':
      nextState = Object.assign(nextState, {
        list: nextState.list.filter(item => {
          return +item.id !== +action.id
        })
      })
      break

    default:
      nextState = state
      break
  }

  return nextState
}
